"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "ShowStep",
    props: {
        current: {
            type: Number,
            required: true
        }
    },
    computed: {
        steps: function () {
            return [
                {
                    id: 1,
                    name: "内容の入力"
                },
                {
                    id: 2,
                    name: "内容の確認"
                },
                {
                    id: 3,
                    name: "送信完了"
                }
            ];
        }
    },
};
